import { awaitRequests, promise } from '../../../helpers';
import { firebaseUpdate } from '../firebase';
import { getCertificates, saveCertificateFiles } from './index';

const updateCertificate = ({ docId, where, data, uploadList }) => {
    // eslint-disable-next-line
    return (dispatch, getState, getFirebase) => {
        // -- update
        const update = (d, id) => dispatch(firebaseUpdate({ collection: 'certificates', docId: id, data: d }));

        // -- after update
        const afterUpdate = item => {
            const reqs = [];

            // upload files
            reqs.push(dispatch(saveCertificateFiles(item, uploadList)));

            return awaitRequests(reqs).then(updatedItem => promise(updatedItem));
        };

        // -- single update
        if (docId && data) {
            return update(data, docId).then(updatedItem => afterUpdate(updatedItem));
        }

        // -- multiple update
        if (where && data) {
            return dispatch(getCertificates({ where })).then(items => {
                return awaitRequests(items.map(item => update(data, item.id).then(updatedItem => afterUpdate(updatedItem))));
            });
        }

        return promise();
    };
};

export default updateCertificate;
